<template>
  <nav class="assist-tabs" :aria-label="$t('assistantCatHome.tabs.label')">
    <tab-button
      :label="$t('assistantCatHome.tabs.request')"
      :icon-src="assistIcon"
      :icon-alt="$t('assistantCatHome.tabs.request')"
      :is-active="activeTab === 'request'"
      @click="$emit('update:activeTab', 'request')"
    />
    <tab-button
      :label="$t('assistantCatHome.tabs.history')"
      :icon-src="historyIcon"
      :icon-alt="$t('assistantCatHome.tabs.history')"
      :is-active="activeTab === 'history'"
      @click="$emit('update:activeTab', 'history')"
    />
  </nav>
</template>

<script lang="ts">
import Vue from "vue";
import TabButton from "@/components/atoms/TabButton.vue";
import assistIcon from "@/assets/icons/assist-icon.svg";
import historyIcon from "@/assets/icons/history-icon.svg";
import { AssistantCatHomeAssistTab } from "@/constants/assistantCatHomeRequest";

export default Vue.extend({
  name: "AssistantCatHomeAssistTabs",
  components: {
    TabButton,
  },
  props: {
    activeTab: {
      type: String as () => AssistantCatHomeAssistTab,
      default: "request",
    },
  },
  data() {
    return {
      assistIcon,
      historyIcon,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

.assist-tabs {
  display: flex;
  flex-shrink: 0;
  width: 100%;
  background-color: var(--color-background-normal);
  border-top: 1px solid var(--color-border);
}

.assist-tabs :deep(.tab-button) {
  flex: 1;
  min-width: 0;
  width: auto;
  height: 56px;
  font-size: var(--font-size-xxs);
  background-color: transparent;
  border-bottom: none;
  border-top: 2px solid transparent;

  &.tab-button--active {
    background-color: var(--color-surface-base);
    border-top-color: var(--color-text-normal);
    border-bottom: none;
  }
}

@include mq("sp") {
  .assist-tabs {
    height: calc(56px + env(safe-area-inset-bottom, 0px));
    padding-bottom: env(safe-area-inset-bottom, 0px);
    border-top: 1px solid var(--color-border);
    background-color: var(--color-background-normal);
  }

  .assist-tabs :deep(.tab-button) {
    height: 56px;
    gap: 4px;
    font-size: var(--font-size-xxs);
    background-color: var(--color-background-normal);
    border: none;
    border-top: 2px solid transparent;
    color: var(--color-text-low);

    &.tab-button--active {
      background-color: var(--color-background-normal);
      border-top-color: var(--color-text-normal);
      color: var(--color-text-normal);
    }
  }

  .assist-tabs :deep(.tab-button__icon) {
    width: 20px;
    height: 20px;
  }
}
</style>
